// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkoglpi{border-radius:var(--ds-border-radius,4px)}._18zr1b66{padding-inline:var(--ds-space-050,4px)}\n._1rjcv77o{padding-block:var(--ds-space-025,2px)}\n._19pkutpp{margin-top:var(--ds-space-150,9pt)}\n._2hwxutpp{margin-right:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
